import appConfigFile from '../../../../app-config';
import moment from 'moment';
import dropOffLocationReducer from '../../DropOff/dropOffLocationReducer';

export const getOpeningHour = (location) => {
  if (location && dropOffLocationReducer.hours) {
    const today = moment();
    const dayOfWeek = moment()
      .format('dddd')
      .toLowerCase();
    let hours = null;
    if (location.hours[dayOfWeek]) {
      hours = location.hours[dayOfWeek];
    }
    const lastOpeningHour =
      hours && hours.length > 0 ? hours[0].substring(11, 20) : null;
    if (
      !lastOpeningHour ||
      moment(lastOpeningHour, 'h:mm A').isBefore(today, 'minutes')
    )
      return false;
    return lastOpeningHour;
  }

  return false;
};

export const initialDynamicOrderMethodType = (appConfig) => {
  const query = new URLSearchParams(window.location.search);
  const type = query.get('type');
  const isDeliveryEnabled = appConfig.accepted_order_types.delivery;
  const isPickUpEnabled = appConfig.accepted_order_types.pickup;
  const isDropOffEnabled = appConfig.accepted_order_types.drop_off;
  if (type && type === 'pickup' && isPickUpEnabled) return 'pickup';
  else if (type && type === 'delivery' && isDeliveryEnabled) return 'delivery';
  else if (isPickUpEnabled && isDeliveryEnabled) return 'pickup';
  else if (isPickUpEnabled && !isDeliveryEnabled) return 'pickup';
  else if (isDeliveryEnabled && !isPickUpEnabled) return 'delivery';
  else if (isDeliveryEnabled && !isPickUpEnabled) return 'delivery';
  else if (isDropOffEnabled && !isPickUpEnabled && !isDeliveryEnabled)
    return 'drop_off';
  else return null;
};

export const formatLocationLabelAsString = (
  location,
  nearestLocation,
  coords
) => {
  let parts = [];
  let isNearestLocation = nearestLocation && location.id === nearestLocation.id;
  if (!location.accepting_orders || !location.is_order_ahead_enabled) {
    parts.push('💤 Closed');
  }

  parts.push(location.name);
  parts.push(location.distance);

  if (isNearestLocation) {
    parts.push('(Nearest Location)');
  }

  return {
    ...location,
    label: coords ? parts.join(' - ') : parts[0],
    isNearestLocation,
  };
};
